import { ActionContext } from 'vuex';
import { IAppRootState } from './IAppRootState';
import { TjipVuexAction, TjipVuexMutation } from '@tjip/vuejs';
import { AppSessionStoreDataModule } from './AppSessionStoreDataModule';
import { ISettings } from '@/model/ISettings';
import * as _ from 'lodash';
import { appSettingsService } from '@/services/appSettingsService';
import { ISetting } from '@/model/ISetting';
import { forEach } from 'lodash';

export class AppSettingsDataModule extends AppSessionStoreDataModule<ISettings, IAppRootState> {
  private static initialData: ISettings = {
    iDealPaymentsDisabled: undefined
  };
  public namespaced = true;

  constructor() {
    super('settings', Object.assign({}, AppSettingsDataModule.initialData));
  }

  @TjipVuexAction
  private getSettings(ctx: ActionContext<ISettings, IAppRootState>, force = false): Promise<ISettings> {
    const data = _.omit(ctx.state, AppSessionStoreDataModule.metaKeys);
    if (force || _.isEqual(data, AppSettingsDataModule.initialData)) {
      return appSettingsService.getSettings(force).then((settings: ISetting[]) => {
        ctx.commit('getSettingsSucceeded', settings);
        return ctx.state;
      });
    }
    return Promise.resolve(ctx.state);
  }

  @TjipVuexAction
  private patchSettings(ctx: ActionContext<ISettings, IAppRootState>): Promise<any> {
    const data = _.omit(ctx.state, AppSessionStoreDataModule.metaKeys) as { [key: string]: ISetting };
    const promises: Promise<any>[] = [];
    for (const prop in data) {
      const setting = data[prop] as ISetting;
      if (setting.value !== setting.originalValue) {
        promises.push(
          appSettingsService.patchSetting(setting).then(() => {
            setting.originalValue = setting.value;
          })
        );
      }
    }
    return Promise.all(promises);
  }

  @TjipVuexMutation
  private getSettingsSucceeded(state: ISettings, value: ISetting[]) {
    const data: { [key: string]: ISetting } = {};
    forEach(value, setting => {
      setting.originalValue = setting.value;
      data[setting.key] = setting;
    });
    Object.assign(state, AppSettingsDataModule.initialData);
    Object.assign(state, data);
  }

  @TjipVuexAction
  protected logout(ctx: ActionContext<ISettings, IAppRootState>) {
    ctx.dispatch('reset');
  }
}
